// import { orange } from '@material-ui/core/colors'
import {
  withStyles,
} from '@material-ui/core/styles'
import {
  FormControl, TextField,
  MenuItem,
  //  Checkbox,
} from '@material-ui/core'
// import { orange } from '@material-ui/core/colors'

const CssTextField = withStyles({
  root: {
    '& label.Mui-focused': {
      color: 'orange',
    },
    '& .MuiInput-underline:after': {
      borderBottomColor: 'orange',
    },
    '& .MuiOutlinedInput-root': {
      borderRadius: '30px',
      '&.Mui-focused fieldset': {
        borderColor: 'orange',
      },
    },
  },
})(TextField)

const CssFormControl = withStyles({
  root: {
    '& MuiSelect.Mui-focused': {
      color: 'orange',
    },
    '& .MuiInput-underline:after': {
      borderBottomColor: 'orange',
    },
    '& .MuiOutlinedInput-root': {
      borderRadius: '30px',
    },
  },
})(FormControl)

const StyledMenuItem = withStyles((theme) => ({
  root: {
    '&:focus': {
      backgroundColor: 'orange',
      '& .MuiListItemIcon-root, & .MuiListItemText-primary': {
        color: theme.palette.common.white,
      },
    },
    '& .MuiOutlinedInput-root': {
      '&.Mui-focused fieldset': {
        borderColor: 'orange',
      },
    },
  },
}))(MenuItem)

// const OrangeCheckbox = withStyles({
//   root: {
//     color: orange[400],
//     '&$checked': {
//       color: orange[600],
//     },
//   },
//   checked: {},
// })((props) => <Checkbox color="default" {...props} />)

export {
  // CssSelect,
  // OrangeCheckbox,
  CssFormControl,
  CssTextField,
  StyledMenuItem,
}
